import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=b6cbce18&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6cbce18')) {
      api.createRecord('b6cbce18', component.options)
    } else {
      api.reload('b6cbce18', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=b6cbce18&", function () {
      api.rerender('b6cbce18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ay15uLUk0K6d/JS/comp/RatingDisplay.vue"
export default component.exports